module.exports = __webpack_public_path__ + "img/celery1.102c66c4.svg";